
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface SlugFieldProps {
  slug: string;
  onSlugChange: (value: string) => void;
}

export function SlugField({
  slug,
  onSlugChange
}: SlugFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="slug">Slug</Label>
      <Input
        id="slug"
        placeholder="enter-assessment-slug"
        value={slug}
        onChange={(e) => onSlugChange(e.target.value)}
        required
        className="font-mono"
      />
      <p className="text-sm text-muted-foreground">
        This will be used in the URL: example.com/assessment/{slug || 'your-slug'}
      </p>
    </div>
  );
}
